import { Tabs } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ProfileTab from "./profile/ProfileTab";
import SiteSettingsTab from "./site-settings/SiteSettingsTab";
import RolePermissionsTab from "./role-permissions/RolePermissionsTab";

import { AuthContext } from "../../../contexts/auth/AuthContext";

export default function SettingsModal() {
  const { t } = useTranslation();
  const [, setActiveKey] = useState("profile");
  const { authState } = React.useContext(AuthContext);

  return (
    <Tabs
      onChange={(key) => setActiveKey(key)}
      destroyInactiveTabPane
      defaultActiveKey="profile"
      centered
    >
      <Tabs.TabPane key="profile" tab={t("profile")}>
        <ProfileTab />
      </Tabs.TabPane>
      
      {!authState.user?.counterpartyId && (
        <Tabs.TabPane key="siteSettings" tab={t("siteSettings")}>
          <SiteSettingsTab />
        </Tabs.TabPane>
      )}
    </Tabs>
  );
}
